import { css } from 'lit';

export default css`
  :host {
    --slider-gap: var(--spacing-4);
    --cut-from-bole: var(--spacing-11);

    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2);
    overflow: hidden;
    position: relative;
  }

  .categories-and-descriptions,
  .images-and-bole {
    --slide-width: 100%;

    display: flex;
    flex-direction: column;
    inline-size: 100%;
  }

  ::slotted([slot="image-slider"]) {
    block-size: var(--spacing-25);
    z-index: 2;
  }

  ::slotted([slot="navigation"]) {
    inset-block-start: calc(var(--spacing-25) / 2);
  }

  .bole-image {
    display: none;
  }

  @media screen and (width >= 992px) {
    :host {
      flex-direction: row;
      gap: 0;
    }

    ::slotted([slot="navigation"]) {
      inset-block-start: 50%;
    }

    .images-and-bole,
    .categories-and-descriptions {
      inline-size: 50%;
    }

    ::slotted([slot="description-slider"]) {
      margin-block-end: var(--spacing-5);
    }

    .images-and-bole {
      --slide-width: calc((100% - var(--slider-gap)) / 2);

      margin-block-end: calc(-1 * var(--cut-from-bole));
    }

    ::slotted([slot="image-slider"]) {
      --first-slide-offset: calc(var(--slide-width) + var(--slider-gap));
      --scroll-snap-align: end;

      block-size: auto;
      margin-block-end: -5%; /* move bottles a little over the bole */
    }

    .bole-image {
      block-size: auto;
      display: block;
      inline-size: var(--slide-width);
      inset-block-end: 0;
      inset-inline: calc(var(--slide-width) + var(--slider-gap)) 0;
      justify-content: flex-end;
      min-block-size: var(--spacing-18);
      object-fit: contain;
      object-position: top right;
      position: relative;
      z-index: 1;
    }
  }
`;
